const toolCallTime = (toolCall) => toolCall.timestamp || toolCall.completed_at || toolCall.created_at;

export const pendingApprovalsFromToolCalls = (toolCalls, lastUserMessageAt = null) => {
  const calls = toolCalls || [];
  const tail = calls[calls.length - 1];
  if (!tail || !tail.awaiting_approval) return [];

  return calls.filter((toolCall) => {
    if (!toolCall.awaiting_approval || toolCall.id == null) return false;
    if (!lastUserMessageAt) return true;

    const at = toolCallTime(toolCall);
    return Boolean(at) && new Date(at) > new Date(lastUserMessageAt);
  });
};

export default pendingApprovalsFromToolCalls;
